require('./hireInformation.scss');

// @vendor
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
const { connect } = require('react-redux');

// @components
import { LoadingSection } from 'commonsComponents/loadingSection';

import PreContractualMailInfo from 'components/contactCenter/preContractualMailInfo/preContractualMailInfo';
import { OKCheckbox } from 'commonsComponents/OKCheckbox';
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const { EmptyState } = require('commonsComponents/emptyState');

// @actions
import { getWizardInfoStepContents } from 'actions/okWizard';

// @utils
import { i18n } from 'core/i18n';
const { FormattedText, formatText } = i18n;
import { HTMLSafeInjector } from 'commonsComponents/htmlSafeInjector';
const { recordPage } = require('utilities/tagging');
import PersonalDataHelper from 'utilities/personalDataHelper';

//@constants
import { DEBIT_CARD_TYPE } from 'constants/index';
import {
  DEBIT_SOLIDARIA_SUBTYPE,
  DEBIT_SOLIDARIA_STANDARD,
} from 'constants/contactCenter/debitCardSubtypes';
const { analyticsId, catalogue } = require('../analytics/hireSolidarityCardAnalytics');

export class HireInformation extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { localGetWizardInfoStepContents, onSetAsCurrentStep, setTermsAndCondsText, processDetail } = this.props;

    onSetAsCurrentStep(this.validate);
    localGetWizardInfoStepContents(__CONTACT_CENTER__ ? 'solidario_cc' : 'solidario');
    recordPage(catalogue[analyticsId.SOLIDARITY_CARD_STEP_1_VIEW]({ productName: processDetail }));

    if (__CONTACT_CENTER__ && !!setTermsAndCondsText) {
      setTermsAndCondsText('hireSolidarityCard-checkboxAgreementText');
    }
  }

  validate = () => {
    if (!__CONTACT_CENTER__) return { isValid: true };

    const { immPrecontractualMail } = this.props;
    const { authorization } = this.props;
    const isMailSent = immPrecontractualMail.get('mailSent');
    const isValidStep = isMailSent && this.props.authorization;

    if (!authorization) {
      this.setState({
        disclaimerErrorState: true,
      });
    } else {
      this.setState({
        disclaimerErrorState: false,
      });
    }

    return {
      isValid: isValidStep,
    };
  };

  buildPreContractualMailInfo() {
    if (!__CONTACT_CENTER__) return null;

    const {
      immProfile,
      immPrecontractualMail,
      requestProfile,
      /* eslint-disable react/prop-types */
      sendPreContractualMail,
      /* eslint-enable react/prop-types */
      link,
      insuranceURL,
      immContracts,
      authorization,
      handleOnChange,
      legalTextAreaLabel,
    } = this.props;

    const disclaimerErrorState = this.state;
    const contractServicesIndividuals =
      (immContracts && immContracts.get('prestacion_servicios_fisicas', '')) || '';

    const profileError = immProfile.get('error');
    const isMailSent = immPrecontractualMail.get('mailSent');
    const clientEmail = PersonalDataHelper.getEmail(immProfile);
    const checkboxLabel = (
      <FormattedText
        value="hireSolidarityCard-checkboxAgreementText"
        injectedStrings={[link, insuranceURL, contractServicesIndividuals]}
      />
    );
    const contractName = 'solidario';
    const sendMailParams = {
      type: DEBIT_CARD_TYPE,
      subType: DEBIT_SOLIDARIA_SUBTYPE,
      standar: DEBIT_SOLIDARIA_STANDARD,
    };
    return (
      <div>
        <PreContractualMailInfo
          email={clientEmail}
          sendEmail={sendPreContractualMail}
          requestProfile={requestProfile}
          preContractualMail={immPrecontractualMail}
          profileError={profileError}
          contractName={contractName}
          sendMailParams={sendMailParams}
          showLegalTextAreaAsWarning={false}
          legalTextAreaLabel={legalTextAreaLabel}
        />
        <OKCheckbox
          extraClass="hire-solidarity-card-view__step1-checkbox"
          idName="tac"
          onChange={handleOnChange}
          label={checkboxLabel}
          errorState={!authorization && disclaimerErrorState}
          errorMessage={
            !authorization && <FormattedText value="hireCardOpenDebit-step3CheckboxErrorMsg" />
          }
          disabled={!isMailSent}
          value={authorization}
        />
      </div>
    );
  }

  render() {
    const { isFetching, error, info } = this.props;

    if (isFetching) {
      return (
        <Fragment>
          <FormattedText
            className="contract-view__wizard__title"
            value="hireSolidarityCard-wizardTitle"
          />
          <LoadingSection />
        </Fragment>
      );
    }
    if (error) {
      const emptyStateTitle = formatText('hireInformationComponent-emptyStateTitle');
      const emptyStateText = formatText('hireInformationComponent-emptyStateText');

      return (
        <Fragment>
          <FormattedText
            className="contract-view__wizard__title"
            value="hireSolidarityCard-wizardTitle"
          />
          <EmptyState
            title={emptyStateTitle}
            primaryText={emptyStateText}
            iconType="nointernet-banking"
          />
          ;
        </Fragment>
      );
    }

    return (
      <Fragment>
        <FormattedText
          className="contract-view__wizard__title"
          value="hireSolidarityCard-wizardTitle"
        />
        <HTMLSafeInjector message={info} customClass="contract-information" />
        <ContactCenterRender>{this.buildPreContractualMailInfo()}</ContactCenterRender>
      </Fragment>
    );
  }
}

HireInformation.propTypes = {
  message: PropTypes.string.isRequired,
  onSetAsCurrentStep: PropTypes.func.isRequired,
  localGetWizardInfoStepContents: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  error: PropTypes.string.isRequired,
  info: PropTypes.string.isRequired,
  insuranceURL: PropTypes.string,
  immProfile: PropTypes.object,
  immPrecontractualMail: PropTypes.object,
  link: PropTypes.string,
  requestProfile: PropTypes.func,
  sendPrecontractualMail: PropTypes.func,
  immContracts: PropTypes.object,
  setTermsAndCondsText: PropTypes.func,
  authorization: PropTypes.bool.authorization,
  disclaimerErrorState: PropTypes.bool.disclaimerErrorState,
  handleOnChange: PropTypes.func,
  legalTextAreaLabel: PropTypes.string,
  processDetail: PropTypes.string,
};

module.exports.HireInformation = connect(
  state => ({
    isFetching: state.okWizard.get('isFetching'),
    error: state.okWizard.get('error'),
    info: state.okWizard.get('info'),
    immContracts: state.globalVariables.getIn(['variables', 'parameters', 'contratos']),
  }),
  {
    localGetWizardInfoStepContents: getWizardInfoStepContents,
  }
)(HireInformation);
